import { Box, TableCell, TableCellProps, useTheme } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC, PropsWithChildren } from 'react'

type TableBodyCellProps = TableCellProps &
  PropsWithChildren & {
    propKey?: string
    paddingLeftKeys?: string[]
    backgroundColor?: string
    width?: string
    fontWeight?: string
    borderBottom?: string
  }

const TableBodyCell: FC<TableBodyCellProps> = ({
  children,
  propKey,
  paddingLeftKeys = [],
  align,
  backgroundColor,
  width,
  fontWeight,
  borderBottom,
  ...otherProps
}) => {
  const theme = useTheme()

  return (
    <TableCell
      className={'fx-nowrap'}
      sx={{
        boxSizing: 'border-box',
        padding: 1,
        position: 'relative',
        '&.MuiTableCell-root': {
          '.MuiBox-root': {
            margin: '0',
          },
          [theme.breakpoints.down('sm')]: {
            border: 'none !important',
          },
        },
        [theme.breakpoints.down('sm')]: {
          padding: '4px 0 4px 0',
        },
        paddingLeft: paddingLeftKeys.includes(propKey ?? '')
          ? '20px'
          : undefined,
        backgroundColor: backgroundColor,
        width,
        fontWeight,
        borderBottom,
      }}
      align={align ?? 'left'}
      {...otherProps}
    >
      <Box>{children}</Box>
    </TableCell>
  )
}

export default observer(TableBodyCell)
